/**
 * @desc 平台站点-修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteResponseDto>;
export function request(
  body: defs.basics.PlatformSiteRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSite/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
